<template>
  <div
    class="items-center justify-end hidden md:flex font-roman text-sm"
  >
    <span class="mr-6">
      {{ user.name }}
    </span>
    <a
      class="cursor-pointer mr-2 text-grey"
      @click.prevent="logout"
    >
      {{ $t('Logout') }}
    </a>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'TheNavbarRightItem',
  computed: mapState('auth', ['user']),
  methods: {
    ...mapActions('auth', ['logout']),
  },
};
</script>
